/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import {is_breakpoint_up, translation, scroll_to, is_visible_in_view, config} from '../helpers/functions';
import Swiper from './../libs/swiper';
import axios from "axios";
import App from './../helpers/app';
import PerfectScrollbar from 'perfect-scrollbar';

$(function(){
    let dataIf = {
        'product': {'rent': 'najmie', 'lease': 'leasingu', 'loan': 'kredycie'},
        'clientType': {'of': 'osoby fizycznej', 'jdg': 'firmy'},
    };

    function initReviewsResizeEvent() {
        let $section = $('.section-offer-reviews');
        if(!$section.length){
            return;
        }

        let ps = null;
        if(is_breakpoint_up('lg')){
            if(ps!==null){
                ps.destroy();
                ps = null;
            }
        }else{
            if(ps===null){
                ps = new PerfectScrollbar($section.find('.reviews-compose')[0]);
            }
        }
    }

    function initReviewsEvent() {
        let $section = $('.section-offer-reviews');
        if(!$section.length){
            return;
        }

        $section.find('.new-review').click(function(){
            $('html').addClass('review-opened');
        });

        $section.find('.compose-close').click(function(){
            $('html').removeClass('review-opened');
        });

        $section.find('.reviews-compose form').submit(function(e){
            e.preventDefault();

            let data = $(this).data('yiiActiveForm');
            if (data && typeof data.validated!=='undefined' && !data.validated) {
                return false;
            }

            let $form = $(this);

            App.loader.init($(this).find('.compose-submit .btn'));

            axios.post('/model/review-compose', $form.serialize())
                .then(function(response){
                    $section.find('.step-form').slideUp();
                    $section.find('.step-success').slideDown();
                    $section.find('.reviews-compose')[0].scrollTop = 0;
                })
                .catch(function(){
                    App.loader.end($(this).find('.compose-submit .btn'));
                });
        });

        $section.find('#recommended-vote').change(function(){
            let label = $(this).is(':checked') ? 'Tak' : 'Nie';
            $(this).closest('.category-item').find('.category-value').html(label);
        }).change();

        $section.find('.compose-vote .vote-stars input').change(function(){
            let labels = {
                '1': 'Bardzo źle',
                '2': 'Źle',
                '3': 'Przeciętnie',
                '4': 'Dobrze',
                '5': 'Bardzo dobrze'
            };
            let label = $(this).is(':checked') ? labels[$(this).val()] : '';
            $(this).closest('.category-item').find('.category-value').html(label);

            $(this).closest('.category-item').find('input[type="hidden"][name*="'+$(this).attr('name')+'"]').val($(this).is(':checked') ? $(this).val() : '');
        }).change();

        $section.on('click', '.helpfully-answer', function(){
            let $btn = $(this);
            let $answers = $btn.closest('.helpfully-answers');
            let $review = $(this).closest('.review-item');

            axios.post('/model/review-vote', $.param({vote: $btn.data('vote'), id: $review.data('id')}))
                .then(function(response){
                    if(!response.data){
                        return;
                    }

                    $answers.find('.helpfully-answer').removeClass('active');
                    $answers.find('.helpfully-answer[data-vote="'+response.data.vote+'"]').addClass('active');
                    $answers.find('.helpfully-answer[data-vote="up"] span').html(response.data.up);
                    $answers.find('.helpfully-answer[data-vote="down"] span').html(response.data.down);

                })
                .catch(function(){

                });
        });

        $section.on('click', '.pagination .page-link', function(e){
            e.preventDefault();

            axios.get($(this).attr('href'))
                .then(function(response){
                    let $html = $(response.data.page.html);

                    let $htmlReviews = $html.find('.reviews-content');

                    let $containerReviews = $('.section-offer-reviews .reviews-content');
                    $containerReviews.empty().append($htmlReviews.children());

                    scroll_to($section.find('.reviews-list'));
                })
                .catch(function(){

                });
        });

        $(window).resize(initReviewsResizeEvent);
        initReviewsResizeEvent();
    }

    initReviewsEvent();

    function initReviewsContentEvent(){
        let $containerReviews = $('.section-offer-reviews');
        if(!$containerReviews.length){
            return;
        }

        let $idaggregate = $containerReviews.find('input[name="ReviewForm[idaggregate]"]').val();

        axios.get('/model/reviews', {params: {idaggregate: $idaggregate}})
            .then(function(response){
                let $html = $(response.data.page.html);

                let $htmlReviews = $html.find('.reviews-content');

                let $containerReviews = $('.section-offer-reviews .reviews-content');
                $containerReviews.empty().append($htmlReviews.children());

                if(is_breakpoint_up('lg') && !$containerReviews.find('.reviews-list .review-item').length){
                    $('.section-offer-reviews').find('.new-review').click();
                }
            })
            .catch(function(){

            });
    }

    setTimeout(initReviewsContentEvent, 1);

    function initCheckVersionsTags(){
        let $section = $('.section-offer-versions');
        if(!$section.length){
            return;
        }

        $('body').removeClass('versions-has-tags');
        if($section.find('.version-thumb.with-tags:visible').length){
            $('body').addClass('versions-has-tags');
        }

        $('body').removeClass('versions-has-uniques');
        if($section.find('.version-thumb.has-uniques:visible').length) {
            $('body').addClass('versions-has-uniques');
        }
    }
    initCheckVersionsTags();

    // Lead
    function leadContainerPosition(){
        let $stickContainer = $('.section-offer-lead .lead-container');

        if($stickContainer.hasClass('is_stuck')){
            return;
        }

        let style = $('style#version-style');
        if(!style.length){
            style = $('<style id="version-style"></style>');
            $('.section-offer-lead').append(style);
        }

        let marginTop = 125;
        let marginBottom = 25;

        let windowHeight = $(window).outerHeight();
        let configHeight = $stickContainer.outerHeight();
        let bannerHeight = $('.section-offer-banner').length ? $('.section-offer-banner').outerHeight() : 0;

        let offset = configHeight - (windowHeight - bannerHeight);

        let minOffset = bannerHeight - $('.section-offer-banner').length ? $('.section-offer-banner .banner-content').offset().top : 0;
        let maxOffset = bannerHeight - marginTop;

        if(offset>maxOffset){
            offset = maxOffset;
        }
        if(offset<minOffset){
            offset = minOffset;
        }

        style.text('.section-offer-lead .lead-container:not(.is_stuck){top:'+(offset*-1)+'px !important;}');
    }

    function initLeadStickyEvent(){
        let $section = $('.section-offer-lead');
        if(!$section.length){
            return;
        }

        let $parentContainer;
        if(is_breakpoint_up('xxl')){
            $parentContainer = $('.section-offer-detail-outer');
        }else{
            $parentContainer = $('.section-offer-detail-inner');
        }

        let $stickContainer = $section.find('.lead-container');
        let $isInitialized = $stickContainer.data('sticky_kit') == true ? true : false;

        if($isInitialized){
            $stickContainer.trigger("sticky_kit:detach");
        }

        if(is_breakpoint_up('lg')){
            let offsetTop = 125 + ($('.header-spacer').length ? $('.header-spacer').outerHeight() : 0);
            if($('.section-offer-used-hero').length){
                offsetTop += 50;
            }

            $stickContainer.stick_in_parent({
                offset_top: offsetTop,
                parent: $parentContainer
            })
                .on("sticky_kit:bottom", function(e) {
                    let $offset = $parentContainer.outerHeight();
                    $stickContainer.css('bottom', $offset*-1);
                })
                .on("sticky_kit:stick", function(e) {

                })
                .on("sticky_kit:unstick", function(e) {
                    leadContainerPosition();
                });

            leadContainerPosition();
        }
    }

    function versionSwiperSlideToActive(version){
        if(version.length){
            let versionsSwiper = $('.section-offer-versions .versions-list-wrapper')[0].swiper;
            if(versionsSwiper){
                let carouselIndex = versionsSwiper.activeIndex;
                let itemActiveIndex = version.parent().prevAll().filter(':visible').length;

                if(is_breakpoint_up('sm')){
                    if(carouselIndex==0 && itemActiveIndex-carouselIndex>1){
                        carouselIndex = 1;
                    }else if(carouselIndex!=0 && carouselIndex!=itemActiveIndex-1){
                        carouselIndex = itemActiveIndex-1;
                    }
                }else{
                    carouselIndex = itemActiveIndex;
                }

                versionsSwiper.slideTo(carouselIndex);
            }
        }
    }

    let $firstLoad = true;
    let $versionSwiperUpdate = false;
    let $priceRequest = null;
    let $versionRequest = null;
    let $relatedRequest = null;
    let $lastCalculation = null;
    let $lastParams = {};
    function initLeadEvents(){
        function populateChanges($form, $scenario){
            let $section = $('.section-offer-lead');
            let $activeVersion = $('.section-offer-versions').find('.version-thumb[data-natcode="'+$section.find('[name="LeadOfferForm[code]"]').val()+'"]');
            let financeType = $section.find('[name="LeadOfferForm[finance_type]"]:checked').val();
            let offerType = $section.find('[name="LeadOfferForm[offer_type]"]:checked').val();

            $section.find('.empty-group').slideUp();
            $section.find('.group-contribution.not-empty-group').slideDown();
            $section.find('.group-mileage.not-empty-group').slideDown();

            if(financeType != 'rent'){
                if(offerType == 'company' && financeType == 'leasing'){
                    $section.find('.group-repurchase').slideDown();
                }else{
                    $section.find('.group-repurchase.not-empty-group').slideUp();
                }
            }else{
                $section.find('.group-repurchase.not-empty-group').slideUp();
            }

            if($section.find('.group-packages').hasClass('empty-group')){
                $section.find('.group-packages.not-empty-group').slideUp();
                $('.section-offer-packages').slideUp();
                $('.section-how-work .packages-container').slideUp();
            }else{
                $section.find('.group-packages').slideDown();
                $('.section-offer-packages').slideDown();
                $('.section-how-work .packages-container').slideDown();
            }

            $('.section-offer-packages .package-item').hide();

            let $packages = [];
            $section.find('.group-packages').first().find('.package-item:visible:not(.disabled) input[type="hidden"], .package-item:visible:not(.disabled) input[type="checkbox"]').each(function(){
                let $package = $(this).closest('.package-item');
                $packages.push('<span class="include include-'+$package.data('package-id')+'">'+$package.data('package-name')+'</span>');
                $('.section-offer-packages .package-item.package-'+$package.data('package-id')).show();
            });

            let $activePackages = [];
            $section.find('.group-packages').first().find('.package-item:visible:not(.disabled) input[type="hidden"], .package-item:visible:not(.disabled) input[type="checkbox"]:checked').each(function(){
                let $package = $(this).closest('.package-item');
                $activePackages.push('<span class="include include-'+$package.data('package-id')+'">'+$package.data('package-name')+'</span>');
            });

            if($packages.length){
                $('.section-offer-packages').show();
            }else{
                $('.section-offer-packages').hide();
            }

            if($activePackages.length){
                $section.find('.offer-includes .includes').empty().append($activePackages.join(' '));
                $section.find('.offer-includes').css({
                    opacity: "",
                    width: "",
                    height: "",
                    overflow: "",
                });
            }else{
                $section.find('.offer-includes').css({
                    opacity: 0,
                    width: 0,
                    height: 0,
                    overflow: 'hidden',
                });
            }

            if(financeType==='loan'){
                $section.find('[data-calculation-display="rrso"]').show();
            }else{
                $section.find('[data-calculation-display="rrso"]').hide();
            }

            $('body').find('.texts-finance_type').html(dataIf['product'][financeType] ?? '');

            let dataIfGenitive = {'rent': 'najmu', 'leasing': 'leasingu', 'loan': 'kredytu'};
            $('body').find('.texts-finance_type--genitive').html(dataIfGenitive[financeType] ?? '');

            if(offerType == 'company' && financeType !== 'loan'){
                $('body').find('.texts-tax').html(translation('netto'));
            }else{
                $('body').find('.texts-tax').html(translation('brutto'));
            }

            if($section.find('[name="LeadOfferForm[code]"]').val() == 'custom'){
                $section.find('.custom-version-selected').slideDown();
                $section.find('.default-version-selected').slideUp();
                $section.find('.empty-version-selected').slideUp();

                $('body').find('.texts-cta').html(translation('formLeadButtonCustomLead'));
            }else if($lastCalculation && !$lastCalculation.offer){
                $section.find('.custom-version-selected').slideUp();
                $section.find('.default-version-selected').slideUp();
                $section.find('.empty-version-selected').slideDown();

                $('body').find('.texts-cta').html(translation('formLeadButtonLead'));
            }else{
                $section.find('.custom-version-selected').slideUp();
                $section.find('.default-version-selected').slideDown();
                $section.find('.empty-version-selected').slideUp();

                $('body').find('.texts-cta').html(translation('formLeadButtonLead'));
            }

            $.each(['finance_type', 'offer_type', 'code'], function(k,v){
                let value = $section.find('[type="checkbox"][name="LeadOfferForm['+v+']"]:checked, [type="radio"][name="LeadOfferForm['+v+']"]:checked, [type="hidden"][name="LeadOfferForm['+v+']"]').val();

                $('body')
                    .removeClassStartsWith('config-'+v)
                    .addClass('config-'+v+'-'+value);
            });

            $.each([{name: 'contribution'}, {name: 'repurchase'}], function(k, v){
                if(v.name=='contribution' || v.name=='repurchase'){
                    let inputs = $section.find('[name^="LeadOfferForm[' + v.name + ']"]');
                    inputs.each(function(){
                        let slider = $(this).next()[0];
                        if(slider && slider.noUiSlider){
                            slider.noUiSlider.updateOptions({}, false);
                        }
                    });
                }
            });

            if($scenario==='before'){
                let $changed = $form.find('[name="LeadOfferForm[user_change]"]').val();
                let $input = $form.find('[name^="LeadOfferForm['+$changed+']"]:checked');

                let $section = $('.section-offer-lead');
                $section.find('[name="'+$input.attr('name')+'"][value="'+$input.val()+'"]:not(:checked)').not($input).val($input.val()).click();
            }

            if($scenario==='after'){
                if($activeVersion.length){
                    if($activeVersion.attr('data-promo-hidden')=='true'){
                        $('body').addClass('promo-hidden');
                    }else{
                        $('body').removeClass('promo-hidden');
                    }
                }
                $section.find('.group-packages .package-item').each(function(){
                    if($(this).find('[type="hidden"]').length || ($(this).find('[type="checkbox"]').length && $(this).find('[type="checkbox"]').prop('checked'))){
                        $('.section-offer-packages .package-item.package-'+$(this).data('package-id')+' .package-checkbox').addClass('active');
                    }else{
                        $('.section-offer-packages .package-item.package-'+$(this).data('package-id')+' .package-checkbox').removeClass('active');
                    }
                    if($(this).hasClass('active')){
                        $('.section-offer-packages .package-item.package-'+$(this).data('package-id')).addClass('required');
                    }else{
                        $('.section-offer-packages .package-item.package-'+$(this).data('package-id')).removeClass('required');
                    }
                });
            }
        }

        let $section = $('.section-offer-lead');
        if(!$section.length){
            return;
        }

        new PerfectScrollbar($section.find('.lead-body')[0]);

        let $html = $('html');
        $section.find('.open-config').click(function (e) {
            $(document).trigger('lead:change');

            $html.toggleClass('config-opened');
            e.preventDefault();
        });

        $section.find('.price-rrso').click(function (){
            scroll_to($('.section-offer-rrso'));
        });

        let $configContainer = $section.find('.lead-container');
        $configContainer.find('.config-close').click(function(){
            $html.removeClass('config-opened');
        });

        $section.find('[name^="LeadOfferForm[packages]"]').change(function(){
            let item = $('.section-offer-packages .package-checkbox label[for="'+$(this).attr('id')+'"]');
            if($(this).is(':checked')){
                item.parent().addClass('active');
            }else{
                item.parent().removeClass('active');
            }
        });

        $section.find('.package-hint .hint-content').click(function(e){
            e.preventDefault();
            $(this).closest('.package-hint').hide();
        });

        $section.find('input[name]').each(function(){
            let name = $(this).attr('name').substring($(this).attr('name').indexOf('[')+1, $(this).attr('name').indexOf(']'));
            let value = $(this).val();

            $(document).trigger('lead:init', [name, value, $(this).is('[type="checkbox"]') || $(this).is('[type="radio"]') ? $(this).is(':checked') : true]);
        });

        $(document).off('change.lead').on('change.lead', '.section-offer-lead input[name]', function(){
            let $input = $(this);
            let $form = $input.closest('form');

            if($form.hasClass('is-loading')){
                return;
            }

            let name = $(this).attr('name');
            name = name.substring(name.indexOf('[')+1, name.indexOf(']'));
            if(name){
                $form.find('[name="LeadOfferForm[user_change]"]').val(name);
            }

            $(document).trigger('lead:change', [name, $(this).val()]);

            $form.submit();
        });

        $(document).off('submit.lead').on('submit.lead', '.section-offer-lead form', function(e){
            if($(this).hasClass('is-lead')){
                return;
            }

            e.preventDefault();

            if($(this).hasClass('is-loading')){
                return;
            }

            let $form = $(this);

            populateChanges($form, 'before');

            if ($priceRequest) {
                $priceRequest.cancel();
                if($configLoader){
                    App.loader.end($configLoader);
                }
                if($priceLoader){
                    App.loader.end($priceLoader);
                }
            }

            if($('.section-offer-lead [name="LeadOfferForm[code]"]').val()==='custom'){
                return;
            }

            $priceRequest = axios.CancelToken.source();

            let $configLoader = $section.find('.lead-content .lead-body');
            App.loader.init($configLoader);

            let $priceLoader = $section.find('.lead-content .price-value, .lead-mobile .price-value');
            App.loader.init($priceLoader, 'button');

            axios.post('/model/price', $form.serialize(), { cancelToken: $priceRequest.token })
                .then(function(response){
                    App.loader.end($configLoader);
                    App.loader.end($priceLoader);

                    let $section = $('.section-offer-lead');

                    $.each(response.data.versions, function(k, v){
                        let thumb = $('.section-offer-versions').find('.version-thumb[data-natcode="'+v.natcode+'"]');
                        thumb.find('.price-old').html(v.prices.old);
                        thumb.find('.price-value').html(v.prices.price);
                        if(v.rating!=='-'){
                            thumb.find('.version-info .info-item.item-rating .info-content span').html(v.rating);
                        }

                        let notFoundTextPart = [];
                        let notFoundText = '';
                        if(v.products.length){
                            notFoundText = 'Tylko w ';
                            $.each(v.products, function (k,v){
                                notFoundTextPart.push(dataIf['product'][v]);
                            });
                        }else{
                            notFoundText = 'Tylko dla ';
                            $.each(v.clientTypes, function (k,v){
                                notFoundTextPart.push(dataIf['clientType'][v]);
                            });
                        }
                        let notFound = notFoundText + notFoundTextPart.join(' i ');

                        if(v.offer){
                            thumb.find('.version-price-not-found').hide();
                            thumb.find('.version-price-found').css('display', 'flex');
                        }else{
                            thumb.find('.version-price-not-found .price-not-found').text(notFound);
                            thumb.find('.version-price-not-found').css('display', 'flex');
                            thumb.find('.version-price-found').hide();
                        }

                        thumb.attr('data-price', v.prices.price_raw);
                        thumb.find('.price-icon').empty().append(v.icon!=='' ? '<i class="ic ic-icon-'+v.icon+'"></i>' : '');

                        thumb.attr('data-promo', v.promotion);
                        thumb.attr('data-promo-hidden', v.promotionHidden);
                        thumb.find('.offer-sticker').show();
                        if(v.promotionHidden==true){
                            thumb.find('.offer-sticker').hide();
                        }
                        thumb.removeClassStartsWith('promo-wyprzedaz-').addClass(v.promotion);
                        thumb.removeClassStartsWith('version-template-').addClass('version-template-'+v.template);

                        let thumbBadges = thumb.find('.version-badges');
                        thumbBadges.find('.offer-price-tag-container').remove();
                        if(v.tags.length){
                            $.each(v.tags, function(tagIndex, tag){
                                let thumbBadge =
                                    $(
                                        '<div class="offer-tag-container offer-price-tag-container tw-flex tw-items-start">' +
                                            '<div class="offer-tag offer-' + (typeof tag.image !== 'undefined' && tag.image ? 'image' : 'text') + '-tag offer-price-tag tag-'+tag.id+' '+tag.type+'-tag">' +
                                                (typeof tag.image !== 'undefined' && tag.image
                                                    ? '<img src="' +tag.image+ '" class="tag-image">'
                                                    : (
                                                        '<div class="tag-label">' +
                                                            tag.label +
                                                        '</div>'
                                                    )
                                                ) +
                                                (typeof tag.value !== 'undefined' && tag.value !== null
                                                    ? '<div class="tag-discount">' + (typeof tag.raw !== 'undefined' && tag.raw ? tag.value : (tag.value + '<small>zł</small>')) + (typeof tag.disclaimer !== 'undefined' && tag.disclaimer ? '*' : '') + '</div>' : ''
                                                ) +
                                            '</div>' +
                                            (typeof tag.disclaimer !== 'undefined' && tag.disclaimer
                                                ? '<div class="tag-disclaimer -tw-ml-1 tw-text-[8px] tw-leading-tight tw-uppercase tw-border-l tw-border-r-0 tw-border-y-0 tw-border-solid tw-pl-2">*' + tag.disclaimer + '</div>' : ''
                                            ) +
                                        '</div>'
                                    );
                                App.registerPlugins(thumbBadge);
                                thumbBadges.prepend(thumbBadge);
                            });
                        }

                        if(thumbBadges.find('.offer-tag').length){
                            thumb.addClass('with-tags');
                        }else{
                            thumb.removeClass('with-tags');
                        }

                        if(v.natcode==response.data.selected){
                            $lastCalculation = v;

                            if(v.prices.old_raw){
                                $('body').find('[data-calculation-display="price-old"]').show();
                            }else{
                                $('body').find('[data-calculation-display="price-old"]').hide();
                            }

                            if(v.prices.electric_raw){
                                $('body').find('[data-calculation-display="price-electric"]').show();
                            }else{
                                $('body').find('[data-calculation-display="price-electric"]').hide();
                            }

                            if(v.prices.start_raw){
                                $('body').find('[data-calculation-display="start"]').show();
                            }else{
                                $('body').find('[data-calculation-display="start"]').hide();
                            }

                            $('body').find('[data-calculation="available-offers"]').html(notFound);
                            $('body').find('[data-calculation="start"]').html(v.prices.start);
                            $('body').find('[data-calculation="price-electric"]').html(v.prices.electric);
                            $('body').find('[data-calculation="price-old"]').html(v.prices.old);
                            $('body').find('[data-calculation="price"]').html(v.prices.price);
                            $('body').find('[data-calculation="price-icon"]').empty().append(v.icon!=='' ? '<i class="ic ic-icon-'+v.icon+'"></i>' : '');
                            $('body').find('[data-calculation="rrso"]').html(v.prices.rrso);

                            const structuredDataElement = document.getElementById('dynamicallyFilledStructuredData');
                            if(structuredDataElement){
                                const structuredData = JSON.parse(structuredDataElement.innerHTML);
                                structuredData.offers.price = v.prices.price_raw;
                                structuredDataElement.innerHTML = JSON.stringify(structuredData);
                            }
                        }
                    });

                    initCheckVersionsTags();

                    $section.find('form').addClass('is-loading');

                    let $paramsAppended = ['finance_type', 'offer_type', 'contract_period', 'contribution', 'repurchase', 'packages', 'mileage'];
                    $lastParams = {};
                    $.address.history(false);
                    $.address.autoUpdate(false);

                    $.each(response.data.config, function(k, v){
                        if($.inArray(v.name, $paramsAppended)!==-1){
                            if(v.name=='packages'){
                                let $url = [];
                                $.each(v.value, function (k2,v2) {
                                    $url.push(k2);
                                });

                                $lastParams[v.name] = $url.join(',');
                            }else{
                                $lastParams[v.name] = v.value;
                            }
                        }

                        if(v.name=='contract_period' || v.name=='offer_type' || v.name=='finance_type'){
                            $section.find('.group-'+v.name+' .group-content .btn-group label').remove();
                            let $active = null;

                            $.each(v.options, function(k2,v2){
                                if(typeof v2!=='object'){
                                    v2 = {
                                        label: v2,
                                        options: {}
                                    };
                                }

                                if(typeof v2.options!=='undefined'){
                                    if(typeof v2.options.disabled!=='undefined'){
                                        return true;
                                    }
                                }

                                let $label = $('<label class="btn '+(k2==v.value ? 'active' : '')+'"><input type="radio" name="LeadOfferForm['+v.name+']" value="'+k2+'" '+(k2==v.value?'checked':'')+' autocomplete="off"><span>'+v2.label+'</span></label>');
                                $section.find('.group-'+v.name+' .group-content .btn-group').append($label);

                                if(k2==v.value){
                                    $active = v.value;
                                }
                            });

                            if($active){
                                $section.find('[name^="LeadOfferForm[' + v.name + ']"][value="' + $active + '"]').click();
                            }
                        }else if(v.name=='contribution' || v.name=='repurchase' || v.name=='mileage' ){
                            let inputs = $section.find('[name^="LeadOfferForm[' + v.name + ']"]');
                            inputs.each(function(){
                                let input = $(this);
                                let slider = input.next()[0];
                                let group = input.closest('.config-group');

                                if(v.options){
                                    let options = {range: {}};

                                    if(typeof v.options === 'object'){
                                        options.range = {min: v.options['min'] ?? 10000, max: v.options['max'] ?? 30000};
                                    }else{
                                        options.range = {min: 0, max: v.options};
                                    }

                                    if(options.range.min == options.range.max){
                                        v.disabled = true;
                                        options.range.max++;
                                    }

                                    slider.noUiSlider.updateOptions(options);

                                    group.removeClass('empty-group');
                                    group.addClass('not-empty-group');
                                    input.removeAttr('disabled');
                                }else if(v.options === null){
                                    group.addClass('empty-group');
                                    group.removeClass('not-empty-group');
                                    input.attr('disabled', true);
                                }

                                if(typeof v.disabled!=='undefined' && v.disabled){
                                    $(slider.noUiSlider.target).attr('disabled', true);
                                }else{
                                    $(slider.noUiSlider.target).removeAttr('disabled');
                                }

                                if(input.val()!=v.value){
                                    slider.noUiSlider.set(v.value);
                                }
                            });
                        }else if(v.name=='packages'){
                            $section.find('.group-packages').removeClassStartsWith('layout-').addClass('layout-' + (v.params.layout ?? 'default'));

                            if(v.options !== null){
                                $section.find('.group-packages').removeClass('empty-group');
                                $section.find('.group-packages').addClass('not-empty-group');

                                $section.find('.group-packages .package-item').attr('data-package-show', 0);

                                $.each(v.options, function (k2,v2) {
                                    if(typeof v2!=='object'){
                                        v2 = {
                                            label: v2,
                                            options: {}
                                        };
                                    }

                                    let inputs = $section.find('[name^="LeadOfferForm[' + v.name + '][' + k2 + ']"]');
                                    if(!inputs.length){
                                        return;
                                    }

                                    let requiredChange = inputs.attr('type') === 'hidden';

                                    inputs.closest('.package-item')
                                        .removeClass('disabled')
                                        .removeClass('active')
                                        .removeClass('required')
                                        .attr('data-package-show', 1);
                                    inputs.attr('type', 'checkbox');

                                    let checked = typeof v.value[k2]!=='undefined' && v.value[k2]=='1';

                                    if(typeof v2.options!=='undefined'){
                                        if(typeof v2.options.disabled!=='undefined'){
                                            checked = false;
                                            inputs.closest('.package-item').addClass('disabled');
                                        }
                                        if(typeof v2.options.required!=='undefined' && v2.options.required) {
                                            inputs.closest('.package-item')
                                                .addClass('active')
                                                .addClass('required');
                                            inputs.attr('type', 'hidden');
                                            requiredChange = false;
                                        }
                                    }

                                    if(requiredChange){
                                        checked = false;
                                    }
                                    inputs.prop('checked', checked);
                                });

                                $section.find('.group-packages .package-item[data-package-show="1"]').show();
                                $section.find('.group-packages .package-item[data-package-show="0"]').hide();
                            }else{
                                $section.find('.group-packages').addClass('empty-group');
                                $section.find('.group-packages').removeClass('not-empty-group');
                                $section.find('.group-packages .package-item').addClass('disabled');
                            }
                        }
                    });

                    let $versionItems = $('.section-offer-versions').find('.version-item').sort(function(a, b) {
                        return $(a).find('.version-thumb').data('price') > $(b).find('.version-thumb').data('price') ? 1 : -1;
                    });
                    $('.section-offer-versions .versions-list').empty().append($versionItems);
                    versionSwiperSlideToActive($('.section-offer-versions .version-thumb.active'));

                    $versionSwiperUpdate = true;

                    if($firstLoad){
                        if($('.section-offer-versions .version-thumb.active[data-special-filter]').length){
                            $(document).trigger('versions-special-filter', [$('.section-offer-versions .version-thumb.active').data('special-filter')]);
                        }

                        $(window).scrollTop(0);

                        $firstLoad = false;

                        let $offer = config('detail');
                        if($offer){
                            dataLayer.push({
                                'ecommerce': {
                                    'detail': {
                                        'actionField': {'list': 'listing'},
                                        'products': [{
                                            'name': $offer.brand+' '+$offer.model,
                                            'id': $offer.idaggregate,
                                            'price': Math.round($lastCalculation.prices.price_raw),
                                            'brand': $offer.brand,
                                            'category': $offer.bodyType
                                        }]
                                    }
                                }
                            });
                        }
                    }else{
                        $.each($lastParams, function (k,v){
                            $.address.parameter(k, v);
                        });
                    }

                    $.address.parameter('q', '');
                    $.address.update();

                    $.address.autoUpdate(true);
                    $.address.history(true);

                    $section.find('form').removeClass('is-loading');

                    $section.find('.lead-init').removeClass('lead-init');

                    initVersionsCustomHeightEvents();

                    populateChanges($form, 'after');
                })
                .catch(function(){

                });
        })

        $section.find('form').submit();

        if($section.hasClass('context-default')){
            $.address.change(function(e){
                let versions = $('.section-offer-versions').find('.version-thumb');
                versions.removeClass('active');

                let code = $.address.parameter('code');
                if(!code || !versions.filter('[data-natcode="'+code+'"]').length){
                    code = $('.section-offer-lead [name="LeadOfferForm[code]"]').val();
                }

                let version = versions.filter('[data-natcode="'+code+'"]');
                version.addClass('active');

                $('body').removeClassStartsWith('version-promo-');
                if(version.data('promo')){
                    $('body').addClass('version-'+version.data('promo'));
                }

                let $versionChanged = false;
                if($('.section-offer-lead [name="LeadOfferForm[code]"]').val()!=code && $versionSwiperUpdate){
                    $('.section-offer-lead [name="LeadOfferForm[code]"]').val(code).change();
                    $versionChanged = true;
                }

                versionSwiperSlideToActive(version);

                if($versionChanged || $firstLoad){
                    let $loader = $('.section-version-detail .loader-content .container-content');
                    App.loader.init($loader);

                    if ($versionRequest) {
                        $versionRequest.cancel();
                    }

                    if(code==='custom'){
                        return;
                    }

                    $versionRequest = axios.CancelToken.source();

                    axios.get('/model/version', {params: {code: code, multisite: window.multisite}, cancelToken: $versionRequest.token})
                        .then(function(response){
                            let $html = $(response.data.page.html);

                            let activeSpec = $('.section-offer-specs .spec-nav .active');

                            let $htmlSpecs = $html.filter('.offer-specs-container').children();
                            $htmlSpecs.removeClass('active show');

                            let $containerSpecs = $('.section-offer-specs .spec-groups');
                            $containerSpecs.find('.group-specs, .group-eq-basic, .group-eq-category, .group-eq-extended, .group-sizes').remove();
                            $containerSpecs.prepend($htmlSpecs);

                            $('.section-offer-specs .spec-nav .nav-link').each(function(){
                               if($($(this).data('target')).length){
                                   $(this).parent().show();
                               }else{
                                   $(this).parent().hide();
                               }
                            });

                            if(!activeSpec.is(':visible')){
                                activeSpec = $('.section-offer-specs .spec-nav .nav-item:visible').first().find('.nav-link');
                            }

                            activeSpec.click();
                            $(activeSpec.data('target')).addClass('active show');

                            initSpecsEqBasicGroupEvents();

                            let $packagesHtml = $html.filter('.packages-container').children();
                            let $containerPackages = $('.offer-packages-container');
                            $containerPackages.empty().append($packagesHtml);

                            App.loader.end($loader);

                            let $version = $('.section-offer-versions .version-thumb.active');
                            let $tags = $version.find('.version-tags').children().clone();

                            let $banner = $('.section-offer-banner');
                            $banner.find('.offer-tags').empty().append($tags);

                            $('.section-offer-related').addClass('is-loading').data('reload', 1);

                            initRelatedScrollEvents();

                            populateChanges(null, 'after');
                        })
                        .catch(function(){

                        });
                }
            });
        }

        if($section.hasClass('context-default')) {
            initLeadStickyEvent();
            $(window).on('resize headerSpacer.resized', function () {
                initLeadStickyEvent();
            });
        }
    }

    initLeadEvents();

    // Banner
    function initBannerEvents(){
        let $section = $('.section-offer-banner');
        if(!$section.length){
            return;
        }

        $section.find('.gallery-icon').click(function(){
            $('.section-offer-gallery .gallery-thumb').first().click();
        });
    }

    initBannerEvents();

    // Versions
    function initVersionsCustomHeightEvents(){
        return;

        let $section = $('.section-offer-versions');
        if(!$section.length){
            return;
        }

        let versions = $section.find('.version-thumb');

        let $versionHeight;
        if(!is_breakpoint_up('lg')){
            $versionHeight = versions.first().outerHeight();
        }else{
            $versionHeight = versions.first().find('.version-body').outerHeight();
        }

        let $customVersion = versions.filter('.version-custom-thumb');
        if(!$customVersion.filter(':visible').length){
            return;
        }

        let heightDiff = $versionHeight - $customVersion.outerHeight();
        $customVersion.find('.custom-image img').height( $customVersion.find('.custom-image img').height(  ) + heightDiff );
    }

    function getMobileActiveVersionSlide(){
        let height = $(window).outerHeight();
        let width = $(window).outerWidth();
        let version;

        $('.section-offer-versions .version-thumb:visible').each(function(){
            var rect = $(this).find('[data-version-onscreen-control]').get(0).getBoundingClientRect();

            if(
                rect.left >= 0 &&
                rect.right <= width
            ){
                version = $(this);
                return false;
            }
        });

        return version;
    }

    function initLeadOptions(){
        $(document).on('lead-submit', function (e, context, action, natcode, el){
            el = el ?? null;
            context = context ?? '';
            action = action ?? '';
            natcode = natcode ?? $('.section-offer-lead [name*="[code]"]').val();

            if(el && el.length){
                App.loader.init(el);
            }

            if ($relatedRequest) {
                $relatedRequest.cancel();
            }

            let $offer = config('detail');

            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'PLN',
                    'add': {
                        'products': [{
                            'name': $offer.brand+' '+$offer.model,
                            'id': $offer.idaggregate,
                            'price': $lastCalculation ? Math.round($lastCalculation.prices.price_raw) : 0,
                            'brand': $offer.brand,
                            'category': $offer.bodyType,
                            'variant': natcode,
                            'quantity': 1
                        }]
                    }
                }
            });

            $.address.history(false);
            $.address.autoUpdate(false);
            $.each($lastParams, function (k,v){
                $.address.parameter(k, v);
            });

            $('.section-offer-lead [name*="[lead_url]"]').val($.address.value());
            $('.section-offer-lead [name*="[context]"]').val(context);
            $('.section-offer-lead [name*="[action]"]').val(action);
            $('.section-offer-lead [name*="[code]"]').val(natcode);
            $('.section-offer-lead form')
                .data('lead', 1)
                .addClass('is-lead')
                .attr('action', '/model/lead?device='+(is_breakpoint_up('lg') ? 'desktop' : 'mobile'));
            $('.section-offer-lead form').submit();
        });

        $(document).on('click', '[data-lead-init], [data-lead-context], [data-lead-action]', function (e){
            e.preventDefault();

            $(document).trigger('lead-submit', [$(this).data('lead-context') ?? undefined, $(this).data('lead-action') ?? undefined, $(this).data('lead-natcode') ?? undefined, $(this)]);
        });
    }

    initLeadOptions();

    function initVersionsEvents(){
        let $section = $('.section-offer-versions');
        if(!$section.length){
            return;
        }

        let versions = $section.find('.version-thumb');

        versions.filter('[data-special-filter]').parent().hide();

        $(document).on('versions-special-filter', function (e, filter){
            let active = $(this).hasClass('active');

            versions.parent().hide();

            if(active){
                $section.find('.versions-filters .nav-link.active').trigger('show.bs.tab');
            }else{
                versions.filter('[data-special-filter="'+filter+'"]').parent().show();
                if(!versions.filter('.active:visible').length){
                    $section.find('.swiper-slide:visible .version-thumb:not(.version-custom-thumb)').first().find('.version-select').click();
                }

                let versionsSwiper = $('.section-offer-versions .versions-list-wrapper')[0].swiper;
                if(versionsSwiper){
                    versionsSwiper.update();
                }

                initCheckVersionsTags();
                initVersionsCustomHeightEvents();
            }

            if(!active){
                $section.find('.versions-filters').hide();
            }else{
                $section.find('.versions-filters').show();
            }

            $(this).toggleClass('active');
        });

        $section.find('.versions-filters .nav-link')
            .on('click', function (e) {
                e.preventDefault()
                $(this).tab('show')
            })
            .on('show.bs.tab', function (e) {
                let filter = $(e.target).data('filter');
                if(!filter){
                    versions.parent().show();
                    versions.filter('[data-special-filter]').parent().hide();
                }else{
                    versions.parent().hide();
                    versions.filter('[data-petrol-filter="'+filter+'"]').parent().show();
                    versions.filter('[data-special-filter]').parent().hide();
                }

                if(!versions.filter('.active:visible').length){
                    $section.find('.swiper-slide:visible .version-thumb:not(.version-custom-thumb)').first().find('.version-select').click();
                }

                let versionsSwiper = $('.section-offer-versions .versions-list-wrapper')[0].swiper;
                if(versionsSwiper){
                    versionsSwiper.update();
                }

                initCheckVersionsTags();
                initVersionsCustomHeightEvents();
            });

        $section.on('click', '.version-thumb .version-body, .version-thumb .version-footer, .version-thumb .version-event', function(e){
            let version = $(this).closest('.version-thumb');

            if($(e.target).data('lead-pdf') || $(e.target).closest('[data-lead-pdf]').length){
                $(document).trigger('lead-submit', ['download', null, version.data('natcode'), $(e.target).is('[data-lead-pdf]') ? $(e.target) : $(e.target).closest('[data-lead-pdf]')]);
                return;
            }

            if($(e.target).data('lead-context') || $(e.target).closest('[data-lead-context]').length){
                let $target = $(e.target).is('[data-lead-context]') ? $(e.target) : $(e.target).closest('[data-lead-context]');
                $(document).trigger('lead-submit', [$target.data('lead-context') ?? null, $target.data('lead-action') ?? null, $target.data('lead-natcode') ?? null, $target]);
                return;
            }

            if(
                (version.data('natcode')==='custom' && is_breakpoint_up('sm'))
                || (version.data('natcode')==='custom' && !is_breakpoint_up('sm') && typeof e.originalEvent!=='undefined' && e.originalEvent.isTrusted===true)
            ){
                return;
            }

            if(
                (version.data('natcode')==='custom' && is_breakpoint_up('lg'))
                || (version.data('natcode')==='custom' && !is_breakpoint_up('lg') && typeof e.originalEvent!=='undefined' && e.originalEvent.isTrusted===true)
            ){
                $(document).trigger('lead-submit', [null, null, version.data('natcode')]);
            }

            if($('.section-offer-lead [name="LeadOfferForm[code]"]').val()==version.data('natcode')){
                return;
            }

            if(!is_breakpoint_up('lg') && typeof e.originalEvent!=='undefined' && e.originalEvent.isTrusted===true){
                return;
            }

            $.address.autoUpdate(true);
            $.address.parameter('code', version.data('natcode'));
        });

        function onSwiperSlideChange(){
            if(!is_breakpoint_up('sm') && $versionSwiperUpdate){
                // let version = $('.section-offer-versions .swiper-slide-active .version-thumb .version-select').click();
                let version = getMobileActiveVersionSlide();
                if(version && version.length){
                    version.find('.version-body').click();
                }
            }
        }

        let versionsSwiper = new Swiper('.section-offer-versions .versions-list-wrapper', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -60,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                }
            },
            navigation: {
                nextEl: '.versions-nav .next',
                prevEl: '.versions-nav .prev',
            },
            pagination: {
                el: '.versions-pagination',
                clickable: true,
                bulletClass: 'page',
                bulletActiveClass: 'active',
            },
            on: {
                sliderFirstMove: function () {
                    versions.find('[data-plugin-tooltipster]').tooltip('hide');
                },
                slideChangeTransitionEnd: onSwiperSlideChange,
                reachEnd: onSwiperSlideChange,
                fromEdge: onSwiperSlideChange,
                transitionEnd: onSwiperSlideChange,
            },
        });

        initVersionsCustomHeightEvents();
        $(window).on('resize', function(){
            initVersionsCustomHeightEvents();
        });
    }

    initVersionsEvents();

    function initSpecsMenu() {
        let $nav = $('.section-offer-specs .spec-nav');
        if(!$nav.length){
            return;
        }

        let navSwiper = $nav[0].swiper;

        if(is_breakpoint_up('lg') && navSwiper){
            navSwiper.destroy();
        }else if(!is_breakpoint_up('lg') && !navSwiper){
            navSwiper = new Swiper('.section-offer-specs .spec-nav', {
                slidesPerView: 'auto',
                freeMode: true,
                observer: true,
                observeParents: true,
            });
        }
    }

    function initSpecsEvents(){
        let $section = $('.section-offer-specs');
        if(!$section.length){
            return;
        }

        initSpecsMenu();
        $(window).on('resize', function(e){
            initSpecsMenu();
        });
    }

    initSpecsEvents();

    // BasicEquipment
    function initSpecsEqBasicGroupEvents(){
        let $section = $('.section-offer-specs');
        if(!$section.length){
            return;
        }

        let $group = $section.find('.eq-content');

        $group.find('.eq-more').click(function(){
            $(this).closest('.eq-content').toggleClass('collapsed');
            let text = $(this).find('[data-collapse-text]');
            if(text.length){
                text.html(text.data($(this).closest('.eq-content').hasClass('collapsed') ? 'collapse-on' : 'collapse-off'))
            }
        });
    }

    initSpecsEqBasicGroupEvents();

    // Colors
    function initSpecsColorsGroupEvents(){
        let $section = $('.section-offer-specs');
        if(!$section.length){
            return;
        }

        let $group = $section.find('.tech-colors');

        $group.find('.tech-color-more').click(function(){
            $group.find('.tech-color.color-hidden').removeClass('color-hidden');
            $(this).hide();
        });
    }

    initSpecsColorsGroupEvents();

    // Related
    function initRelatedScrollEvents() {
        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        if(is_visible_in_view($section, 'any', -500) && $section.data('reload')){
            $section.data('reload', 0);

            initRelatedAjaxEvents();
        }
    }

    function initRelatedEvents() {
        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        $(window).scroll(function () {
            initRelatedScrollEvents();
        });
        initRelatedScrollEvents();
    }

    initRelatedEvents();

    function initRelatedAjaxEvents(){
        let $visitor_id;
        if(typeof _paq !== 'undefined'){
            _paq.push([ function() { $visitor_id = this.getVisitorId(); }]);
        }

        let $natcode = $('.section-offer-lead [name="LeadOfferForm[code]"]').val();

        $relatedRequest = axios.CancelToken.source();

        axios.get('/model/related', {params: {visitor_id: $visitor_id, natcode: $natcode}, cancelToken: $relatedRequest.token})
            .then(function(response){
                let $html = $(response.data.page.html);
                let $htmlRelated = $html.filter('.section-offer-related').find(' .swiper-outer-container');

                let $containerRelated = $('.section-offer-related');

                $containerRelated.find('.swiper-outer-container').remove();
                $htmlRelated.insertAfter($containerRelated.find('.not-found'));

                $containerRelated.removeClass('is-loading').data('reload', 0);


                initRelatedSwiperEvents();
            })
            .catch(function(){

            });
    }

    function initRelatedSwiperEvents(){
        let $section = $('.section-offer-related');
        if(!$section.length){
            return;
        }

        new Swiper('.section-offer-related .offer-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -10,
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -60,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
                1280: {
                    slidesPerView: $section.hasClass('context-offer-not-found') ? 2 : 3,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                }
            }
        });
    }

    // Related
    function initVideoEvents(){
        let $section = $('.section-offer-video');
        if(!$section.length){
            return;
        }

        new Swiper('.section-offer-video .video-container', {
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -45,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    slidesOffsetAfter: -60,
                },
                992: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesOffsetAfter: 0,
                },
            }
        });
    }

    initVideoEvents();
});
